import { Component, OnDestroy } from '@angular/core';
import { CanvasService } from '../canvas.service';
import { CanvasHelperService } from '../canvas-helper.service';

@Component({
  selector: 'app-canvas-citations',
  templateUrl: './canvas-citations.component.html',
  styleUrl: './canvas-citations.component.scss',
})
export class CanvasCitationsComponent implements OnDestroy {
  docuemntContentDetails: any = null;
  selectedSource: any = null;
  isLoadingDocument: boolean = false;

  constructor(
    public canvasService: CanvasService,
    private readonly helperService: CanvasHelperService
  ) {}

  ngOnDestroy(): void {
    this.canvasService.clearCitations();
  }

  onSourceClicked(source: any) {
    if (source.url) {
      this.canvasService.openExternalLink(source.url);
    } else if (source.dataset_id) {
      this.helperService.openDatasetDetails(source.dataset_id);
    } else if (source.document_id) {
      this.helperService.openDocumentCitationDetails(source);
    } else if (source.excel_dataset_id) {
      this.canvasService
        .getLocalExcelDetails(source.excel_dataset_id)
        .subscribe();
    }
  }
}
